"use client"

import { useState } from "react"

const BAR_COLOR = "var(--color-primary, #6366f1)"
const GRID_COLOR = "var(--color-border, #e5e7eb)"

export function ScoreDistributionChart({ data = [] }) {
  const [hoveredKey, setHoveredKey] = useState(null)
  const maxCount = Math.max(...(data?.map((d) => d?.count) || [1]), 1)

  return (
    <div
      className="relative w-full rounded-lg border border-border bg-background overflow-hidden"
      style={{ "--grid-color": GRID_COLOR }}
    >
      <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(to_right,var(--grid-color)_1px,transparent_1px),linear-gradient(to_bottom,var(--grid-color)_1px,transparent_1px)] bg-[size:24px_24px] opacity-40 [mask-image:radial-gradient(ellipse_60%_60%_at_50%_50%,#000_60%,transparent_100%)]" />

      <div className="relative z-10 flex items-end gap-4 sm:gap-6 h-48 px-6 pt-8 pb-2">
        {data?.map((bucket) => {
          const heightPct = maxCount > 0 ? Math.max((bucket?.count / maxCount) * 100, bucket?.count > 0 ? 6 : 2) : 2
          const isHovered = hoveredKey === bucket?.key
          return (
            <div
              key={bucket?.key}
              className="flex-1 flex flex-col items-center justify-end h-full cursor-pointer"
              onMouseEnter={() => setHoveredKey(bucket?.key)}
              onMouseLeave={() => setHoveredKey(null)}
            >
              {isHovered && (
                <div className="mb-1 text-xs font-semibold text-foreground bg-card border border-border rounded-md px-2 py-1 shadow-sm">
                  {bucket?.count}
                </div>
              )}
              <div
                className="w-full max-w-10 rounded-t-md transition-all duration-300 ease-out"
                style={{
                  height: `${heightPct}%`,
                  backgroundColor: BAR_COLOR,
                  opacity: isHovered ? 1 : 0.75,
                  transform: isHovered ? "scaleX(1.08)" : "scaleX(1)",
                }}
              />
            </div>
          )
        })}
      </div>

      <div className="relative z-10 flex gap-4 sm:gap-6 px-6 pb-4">
        {data?.map((bucket) => (
          <div key={bucket?.key} className="flex-1 text-center text-xs font-medium text-muted-foreground">
            {bucket?.label}
          </div>
        ))}
      </div>
    </div>
  )
}

export default ScoreDistributionChart